import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Paper } from "helpers/api";

export const MAX_PAPER_SOURCES = 5;

interface SourcesState {
  sources: Paper[];
}

const initialState: SourcesState = {
  sources: [],
};

const sourcesSlice = createSlice({
  name: "sources",
  initialState,
  reducers: {
    addSource(state: SourcesState, { payload }: PayloadAction<Paper>) {
      if (state.sources.length >= MAX_PAPER_SOURCES) return;

      // Check if source already exists to prevent duplicates
      const exists = state.sources.some((s) => s.paper_id === payload.paper_id);
      if (!exists) {
        state.sources = [...state.sources, payload];
      }
    },
    removeSource(state: SourcesState, { payload }: PayloadAction<string>) {
      state.sources = state.sources.filter(
        (source) => source.paper_id !== payload
      );
    },
    clearSources(state: SourcesState) {
      state.sources = [];
    },
    setSources(state: SourcesState, { payload }: PayloadAction<Paper[]>) {
      state.sources = payload;
    },
  },
});

export const selectSources = (state: { sources: SourcesState }) =>
  state.sources.sources;

export const selectCanAddSource = (state: { sources: SourcesState }) =>
  state.sources.sources.length < MAX_PAPER_SOURCES;

export const { addSource, removeSource, clearSources, setSources } =
  sourcesSlice.actions;

export default sourcesSlice.reducer;
